"use strict";
/**
 * @module Services.Timeseries
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link TimeSeriesEditRequest}
 */
var TimeSeriesEditRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(TimeSeriesEditRequestSerialiserClass, _super);
    function TimeSeriesEditRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link TimeSeriesEditRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link TimeSeriesEditRequest} to be written
     */
    TimeSeriesEditRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.path);
        Codec.writeString(bos, value.dataType.name());
        Codec.writeInt64(bos, value.sequence);
        Codec.writeBytes(bos, value.value);
    };
    return TimeSeriesEditRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TimeSeriesEditRequestSerialiserClass = TimeSeriesEditRequestSerialiserClass;
/**
 * The {@link TimeSeriesEditRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TimeSeriesEditRequestSerialiser = new TimeSeriesEditRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/timeseries/time-series-edit-request-serialiser.js
// module id = 2030
// module chunks = 1